var styles = {
  "iconLeft": "pb-ButtonLinkBase__iconLeft",
  "iconRight": "pb-ButtonLinkBase__iconRight",
  "anchor": "pb-ButtonLinkBase__anchor",
  "hasMaxWidth": "pb-ButtonLinkBase__hasMaxWidth",
  "buttonTextLeft": "pb-ButtonLinkBase__buttonTextLeft",
  "buttonTextRight": "pb-ButtonLinkBase__buttonTextRight",
  "flexContainer": "pb-ButtonLinkBase__flexContainer"
};
export default styles;